import * as yup from 'yup';
import ValidationMessage from '../../constants/ValidationMessage';

const ProfileValidation: any = yup.object().shape({
    name: yup.string().required(ValidationMessage.Field("your name"))
        .min(2, ValidationMessage?.MinLength("Your name", 2))
        .max(25, ValidationMessage?.MaxLength("Your name", 25)),

    email: yup.string().required(ValidationMessage.Field("email"))
        .email(ValidationMessage.EMAIL_ADDRESS)
        .matches(ValidationMessage.EMAIL_REGREX, ValidationMessage.EMAIL_ADDRESS)
        .max(150, ValidationMessage.MaxLength('Email', 150))
        .trim(),

    // phone_number: yup.string()
    //     .required(ValidationMessage.Field("phone number"))
    //     .min(7, ValidationMessage.VALID_PHONE_NUMBER)
    //     .max(15, ValidationMessage.PHONE_MAX_CHAR)
    //     .matches(/^[0-9]*$/, ValidationMessage.VALID_PHONE_NUMBER)
    //     .test('valid-phone', ValidationMessage.VALID_PHONE, value => {
    //         if (!value) return true;
    //         if (/^0+$/.test(value)) {
    //             return false;
    //         }
    //         return true;
    //     }),

    country: yup.string().required(ValidationMessage.SelectField("a country")),
    state: yup.string().required(ValidationMessage.SelectField("a state")),
    // income: yup.string().required(ValidationMessage.Field("Income")),
    locality: yup.object().typeError("Please select a locality.").required("Please select a locality."),
    // share_usage_data: yup
    //     .boolean()
    //     .oneOf([true], "Please accept the Privacy Policy.")
    //     .required("Please accept the Privacy Policy."),
    // .required('Profile image is required')
    // .test('fileSize', 'File size is too large', (value: any) => {
    //     return value && value[0]?.size <= 2000000; // Check if file size <= 2MB
    // })
    // .test('fileType', 'Unsupported file format', (value: any) => {
    //     return value && ['image/jpeg', 'image/png'].includes(value[0]?.type); // Allow only jpeg and png formats
    // })


    // profile_image: yup.string().required(),
    // profile_pic: yup
    //     .mixed()
    //     .required('Profile image is required')
    // .test(
    //     'fileSize',
    //     'File size is too large (max 5MB)',
    //     (value:any) => value && value[0] && value[0].size <= 5000000 // 2MB limit
    // )
    // .test(
    //     'fileType',
    //     'Unsupported file format. Only JPEG and PNG are allowed',
    //     (value:any) => value && value[0] && ['image/jpeg', 'image/png'].includes(value[0].type)
    // ),
    // Other fields validation

    // national_cost: Yup.string().required(ValidationMessage.Field("national cost")).max(5, ValidationMessage.MaxLength('national cost', 5))

});

export default ProfileValidation;

